import { Pipe, PipeTransform } from '@angular/core';
import { ImageDescription, MediaIdentifier } from '@fitscovery/partner/data-access';

@Pipe({
  name: 'imageDescription'
})
export class ImageDescriptionPipe implements PipeTransform {

  transform(imageDescriptions: ImageDescription[], identifier: MediaIdentifier): ImageDescription | undefined {
    return imageDescriptions?.find((imageDescription: ImageDescription) => imageDescription?.identifier === identifier);
  }

}
